<onyx-section [heading]="`${I18N}.heading`">
  <form [formGroup]="form()">
    @let controls = form().controls;
    <onyx-datepicker
      [formControl]="controls.issuingDate"
      label="labels.issueDate"
      [yearsRange]="{ past: 20, future: 0 }"
      [size]="32"
    ></onyx-datepicker>

    <onyx-upload
      [formControl]="controls.scans"
      label="labels.certificateScan"
      [limit]="2"
      [size]="32"
    ></onyx-upload>
  </form>
</onyx-section>
